<template>
  <el-input
    :placeholder="(inputComponentData && inputComponentData.placeholder) || inputPlaceholder"
    v-model="value[inputKey]"
    :style="{ width: '450px' }"
    clearable
    v-bind="inputComponentData"
  >
    <template slot="prepend">
      <z-select
        :options="options"
        :popperAppendToBody="false"
        v-model="value[selectKey]"
        :style="{ width: selectWidth }"
        @change="handleSelectChange"
        v-bind="selectComponentData"
      ></z-select>
    </template>
    <i class="el-icon-search el-input__icon" slot="suffix"></i>
  </el-input>
</template>
<script>
export default {
  name: 'ZSelectInput',
  props: {
    value: {},
    options: {
      type: Array,
      default: () => []
    },
    selectKey: {
      type: String,
      default: ''
    },
    inputKey: {
      type: String,
      default: ''
    },
    componentData: {
      type: Object
    },
    selectComponentData: {
      type: Object
    },
    inputComponentData: {
      type: Object
    },
    selectWidth: {
      type: String,
      default: '120px'
    },
    inputWidth: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      val: [],
      oldValue: this.value[this.selectKey] || ''
    }
  },
  computed: {
    inputPlaceholder () {
      const item = this.options.find(item => item.value === this.value[this.selectKey])
      if (item) {
        if (item.placeholder) {
          return item.placeholder
        }
        return this.$t('system::common::input_holder') + item.label + this.$t('system::common::input_search')
      }
      return this.$t('system::common::input_holder')
    }
  },
  watch: {
    componentData: {
      handler: function () {
        console.log(this.componentData, 'componentData', this.selectComponentData)
      },
      immediate: true
    },
  },
  mounted () {},
  methods: {
    handleSelectChange (val) {
      this.$emit('input', { ...this.value, [this.inputKey]: '', [this.oldValue]: '' })
      this.oldValue = val
    }
  }
}
</script>
